// extracted by mini-css-extract-plugin
module.exports = {"proBanner":"SupportBanner_proBanner__mZM9f","supportSel":"SupportBanner_supportSel__kMkPL"};